var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "table-row-action" },
    [
      _vm._l(_vm.normalizedActions.normal, function (action) {
        return [
          action.tooltip
            ? _c(
                "el-tooltip",
                _vm._b(
                  {
                    key: action.tooltip,
                    staticClass: "table-row-action-tooltip",
                    attrs: { content: action.tooltip },
                  },
                  "el-tooltip",
                  Object.assign(
                    {},
                    { effect: "light", placement: "top" },
                    action.tooltipProps || {}
                  ),
                  false
                ),
                [
                  _c(
                    "MonitorComponent",
                    {
                      attrs: {
                        monitor: action.monitor,
                        "monitor-extra": { row: _vm.row },
                      },
                    },
                    [
                      _c(
                        "el-button",
                        _vm._b(
                          {
                            staticClass: "table-row-action-tooltip__button",
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(action)
                              },
                            },
                          },
                          "el-button",
                          Object.assign(
                            {},
                            { size: "mini" },
                            action.buttonProps
                          ),
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "MonitorComponent",
                {
                  key: action.label,
                  attrs: {
                    monitor: action.monitor,
                    "monitor-extra": { row: _vm.row },
                  },
                },
                [
                  _c(
                    "el-button",
                    _vm._b(
                      {
                        key: action.label,
                        staticClass: "table-row-action-button",
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(action)
                          },
                        },
                      },
                      "el-button",
                      Object.assign({}, { size: "mini" }, action.buttonProps),
                      false
                    ),
                    [_vm._v(_vm._s(action.label))]
                  ),
                ],
                1
              ),
        ]
      }),
      _vm._v(" "),
      _vm.normalizedActions.group.length
        ? _c(
            "el-dropdown",
            _vm._b(
              { staticClass: "table-row-action-group" },
              "el-dropdown",
              Object.assign({}, { size: "small" }, _vm.groupDropdownProps),
              false
            ),
            [
              _c(
                "el-button",
                {
                  staticClass: "table-row-action-group-link",
                  attrs: { size: "mini", type: "text" },
                },
                [
                  _vm._v(_vm._s(_vm.groupDropdownText)),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.normalizedActions.group, function (action) {
                  return _c(
                    "MonitorComponent",
                    {
                      key: action.tooltip || action.label,
                      attrs: {
                        "monitor-extra": { row: _vm.row },
                        monitor: action.monitor,
                      },
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          key: action.label,
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleClick(action)
                            },
                          },
                        },
                        [
                          action.buttonProps.icon
                            ? _c("i", {
                                staticClass: "table-row-action-group-icon",
                                class: action.buttonProps.icon,
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(action.tooltip || action.label)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }